/* jshint eqnull:true */
define([
	"require",
	"jquery",
	"domReady",
	"wcs.product-list-view",
	"wcs.utils",
	"wcs.alert",
	"wcs.context",
	"wcs.product-grid",
	"shared.main.plugins",
	"shared.main.screen",
	"wcs.product-context",
	"pubsub",
	'promise!wcs.zmetrics',
	"datalayer.wcs.product-list",
	'shared.main.history'
], function(require, $, domReady, productView, utils, alertIndicator, context, productGrid, pluginLoader, screenSize){

	var DEBUG = false;
	var EVENT_DEBUG = false;
	var prevURL = '' ;

	var lockLazyLoadAjax = false;									//If set to TRUE it will prevent an AJAX call
	var enableLazyLoad = false;										//If set to TRUE it will make AJAX calls to fetch results on scroll
	var totalResults = parseInt ( $('.total-count-js').val());		//Cache total number of results
	var autoEnableLazyLoad = false;									//If set to TRUE, enable lazy load by default (no Show All link to click)
	//this variable is to be used to make sure multiple lazy load events aren't triggered simultaneously; wait until one completes before firing another one
	var isGridLayoutImagePresetsEnabled =  WCS_CONFIG.get('grid::gridLayoutImagePresetsEnabled');
	var processing = false;
	var disallowScroll = true;										//Used to prevent the scroll event from happening when the user hits the back button
	var currentScrollPosition = 0;									//Used to keep track of the user's last scroll position for back button usage
	var endlessScrollCookieExists = false;							//Used to keep track of whether the endless scroll cookie exists for manipulating AJAX states
	var pagesLoaded = 0;											//Used to keep track of the number of endless scroll pages loaded
	var endlessScrollCookieName = 'VF_ENDLESS_SCROLL';				//Cookie name used for the endless scroll cookie to remember the back button position
	var clickedProductCookieName = 'VF_CLICKED_PRODUCT'; // Cookie that stores clicked product
	var isEASearchTemplate = $('.ea-js').length > 0 ? true : false;	//If length is not zero, then ea template is used.
	var isSimpleFacetEnabled = WCS_CONFIG.get('grid::facetEngine') === 'simpleFacets' ? true : false;
	var eaMultiSelectFacetEnabled = (isEASearchTemplate && WCS_CONFIG.get('grid::easyAskMultiSelectFacetEnabled'));
	var isBRSearchTemplate = $('.br-js').length > 0 ? true : false;  //If length is not zero, then br template is used.
	var originalRequestAction = "";									//This stores a reference to the original request action for EA.
	var triggerScroll = false;
	var displayLoadMoreButton = false;
	var filtersListElement = $('#nav-dept');
    var productListUnusedFiltersStartCollapsed = WCS_CONFIG.grid.productListUnusedFiltersStartCollapsed || {};
	var pageSizeByDeviceEnabled = (WCS_CONFIG.grid.pageSizeByDeviceEnabled && ($('body').data("pageType") === "prodlistgrid"));
	var pageSizeRemainingNumberOnButtonEnabled = WCS_CONFIG.grid.pageSizeRemainingNumberOnButtonEnabled;
    var facetAfterCollapse = [];
    var filterProductsOnPageLoad = true;
    var doFetchProducts = false;
    var doResetFilters  = false;
    var optimizeRequestsEnabled = WCS_CONFIG.get('global::optimizeRequestsEnabled');
    var loadMoreRemainingOpenBracket = '(';
    var loadMoreRemainingCloseBracket = ')';
    var enablePerformanceMarks = WCS_CONFIG.grid.productGridEnablePerformanceMarks || false;
    var facetClickDetected = false;  //for use with performance marks
    var filteringFacetsOnPageLoadDetected = false;
	var BOOMRavailable = (typeof BOOMR !== "undefined"); // required to send performance marks to mPulse
	var facetDecodingEnabled = WCS_CONFIG.get('grid::facetDecodingEnabled');
	var shortDescriptionTruncate = WCS_CONFIG.get('grid::shortDescriptionTruncate') || false;
	var shortDescriptionTruncateLengthLarge = WCS_CONFIG.get('grid::shortDescriptionTruncateLengthLarge') || 150;
	var shortDescriptionTruncateLengthSmall = WCS_CONFIG.get('grid::shortDescriptionTruncateLengthSmall') || 50;
	var loyaltyCookieUrl = context.getURLWithContextRoot('VFCAjaxLoyaltySummary');
	var loyaltyCookieName = 'LOYALTYPOINTBALANCE';
	var updatePlpLoyaltyCookie = WCS_CONFIG.get('grid::updatePlpLoyaltyCookie') || false;
	var plpFiltersAndSortBtnEnabled = WCS_CONFIG.get('grid::plpFiltersAndSortBtnEnabled') || false;
	var plpMobileFiltersMultiSelectEnabled = false;
	var plpResetSortOnClearAllFilters = WCS_CONFIG.get("grid::plpResetSortOnClearAllFilters") || false;
	var reloadFilters = false;
	var plpCustomSortByOptions = WCS_CONFIG.get("grid::plpCustomSortByOptions") || false;
	var plpAddFacetidFieldAnalytics = WCS_CONFIG.get('grid::plpAddFacetidFieldAnalytics') || false;
	var leftNavFilterDesktopWithMobileModal = WCS_CONFIG.get('grid::leftNavFilterDesktopWithMobileModal') || false;
	var plpPriceRangeEnableEditableInputs = WCS_CONFIG.get('grid::plpPriceRangeEnableEditableInputs') || false;
	var plpTopNavDesktopEnabled = WCS_CONFIG.get('grid::plpTopNavDesktopEnabled');
	var lightCheckMarkColor = '#FFFFFF';
	var darkCheckMarkColor = WCS_CONFIG.get('grid::darkCheckMarkColorLeftNavFilters') || '#929292';
	var maxSelectedFacetsVisibleDesktop = (WCS_CONFIG.get('grid::maxSelectedFacetsVisibleDesktop')-1) || 8;
	var plpFacetFiltersRemoveDuplicateUrlEnabled = WCS_CONFIG.get('grid::plpFacetFiltersRemoveDuplicateUrlEnabled') || false;
	var isShowMoreVisible = true;

	if(screenSize.size() === 'small') {
		plpMobileFiltersMultiSelectEnabled = WCS_CONFIG.get('grid::plpMobileFiltersMultiSelectEnabled') || false;
	}
	var toggleFilterValues =  {
		desktopHeight: 42,
		mobileHeight: 45,
		applyFilters: 'Apply Filters',
		viewAllFilters: 'View All',
	};

	function getFacetCollapse()
	{
		if(DEBUG) console.log('getFacetCollapse()');
		return $('.collapsed').map(function(){
			return $(this).data('attributeId');
		});
	}

	function setFacetCollapse(facetAfterCollapse)
	{
		if(DEBUG) console.log('setFacetCollapse()');
		$.each(facetAfterCollapse, function(index,value)
		{
			$('div[data-attribute-id = "'+value+'"]').addClass('collapsed');
		});
	}

	if (plpFiltersAndSortBtnEnabled) {
		$(document).on('click',".plp-close-filters, .icon-close", function (event) {
			if($('.filter-search-btn-js').hasClass('filters-expanded')) {
				$('.filter-search-btn-js').trigger('click');
			}
		});
	}

	/*This function returns an updated facet list. If the facet exists
	 * in the list, then remove it from it; otherwise, add it.
	 *@param facetValue: is the facet to add or remove from the list
	 *@param facetList: is the list of applied facets
	 *@param event: the click event
	 */
	function updateFacetList (facetValue, facetList, event) {
		if(DEBUG) console.log('updateFacetList()', facetValue);
		var index = $.inArray (facetValue, facetList);
		if (index === -1) {
			index = $.inArray (encodeURI(facetValue), facetList);
		}
		if (index === -1) {
			//Add facetValue to facetList
			facetList.push (facetValue);
		}
		else {
			//Remove facetValue from facetList
			var filtersRemoved = facetList.splice (index,1);
			if (WCS_CONFIG.get('global::fredHopperEnabled') && (!WCS_CONFIG.get('HandleBarsModules::TopBarFacets') || leftNavFilterDesktopWithMobileModal)) {
				if (filtersRemoved.length > 0) {
					filters = parseFacetParam(filtersRemoved);
					filterValues = filters.filterValues;
					filterCategories = filters.filterCategories;
					if (leftNavFilterDesktopWithMobileModal) {
						var $selectedFacet = $('.facet-value[data-facet-value="'+facetValue+'"]').length > 0 ? $('.facet-value[data-facet-value="'+facetValue+'"]') : $('.attr-box[data-facet-value="'+facetValue+'"]');
						$facetSelector = $selectedFacet.parents('.filter-group');
					} else {
						$facetSelector = $('button[data-facet-value="'+facetValue+'"]').parents('.filter-group');
					}
					if ($facetSelector.length > 0) {
						facetIds = [$facetSelector.data('facet-id')];
					}
					$.pubsub('publish', 'vfdp.wcs.product_list.FILTERS_CHANGED', {eventLabel: 'Remove', filterCategories: filterCategories, filterValues: filterValues, facetIds: facetIds});
				}
			}

			$.pubsub('publish', 'vfdp.wcs.product_list.RESET_FILTERS_BREADCRUMB_CLICKED', {facetValue: facetValue, target: event.target});
		}

		return facetList;
	}
	function removePriceFacet (facetValue, facetList) {
		if(DEBUG) console.log('removePriceFacet()');
		var priceIndex = null;
		jQuery.each( facetList, function( index, val ) {
			  if(val.toLowerCase().indexOf("price") >= 0){
				  priceIndex = index;
			  }
		});
		if (priceIndex != null) {
			facetList.splice (priceIndex,1);
		}
	}

	/*This function removes all the price slider parameters from the catPath (EasyAsk search)
	 * and updates it in the markup; this is necessary due to the following instructions from EA (VFDP-12127):
	 * Once you select a min or max price for the first time, you get the selected price range information
	 * in path node of JSON response. Subsequent selections can be handled in 2 ways.
	 *  1. Submit as BreadCrumb click: When submitting the changed price slider values, you
	 *     can modify the price slider information in the path and submit it as a breadcrumb click with the modified path.
	 *  2. Submit as Attribute Selection: In this case, extract the Price Slider part of the path and submit
	 *     the modified path as path and the new price slider info as attribSel parameter. */
	function removePriceSliderFacetFromCatPath () {
		if(DEBUG) console.log('removePriceSliderFacetFromCatPath()');
		var catPath = $('.ajax-product-search-js').data('catPath');
		var facet = $("#priceFacetSelected" ).val();
		if(facet){
			if ( !WCS_CONFIG.get('HandleBarsModules::TopBarFacets') ) {
				facet = encodeURIComponent(facet).replace(/%20/g, "+").replace(/'/g, "%27");
			}

			catPath = catPath.replace(facet, "");
		}
		$('.ajax-product-search-js').data('catPath', catPath);
	}
	/*This function removes all the facet parameters from the string query and
	 * returns the new url. If no facets are found then the original url is returned.
	 * @param url: url
	 */
	function removeFacetsFromURL (url){
        if(DEBUG) console.log('removeFacetsFromURL()');
        if (url && url.indexOf ('facet') > -1) {
			var upperBound = url.indexOf ('?'),
				urlBase = url.substring (0, upperBound + 1),
				queryString = url.substring (upperBound +1),
				params = queryString.split ('&'),
				numParams = params.length;

			var modifiedParams = [];
			for (var i = 0; i < numParams; i++) {
			    if (params[i].indexOf ('facet') === -1){
			    	modifiedParams.push(params[i]);
			    }
			    else if(params[i].indexOf ('persistfacet') === 0){
			    	//Some facets should not be removed and have been given a special param name to distinguish.  These facets need the param name changed to "facet"
			    	//Original param is still added to avoid removal of facet later on
			    	modifiedParams.push(params[i]);
                	modifiedParams.push('facet' + params[i].substring(params[i].indexOf('=')));
			    }
			}
			return urlBase + modifiedParams.join('&');
		}
		return url;
	}

	//This fn should be called for loading more products using lazy loading.
	function loadMoreProducts(URL, pages, showLoadingNotification, isPartialLoad) {
		if(DEBUG) console.log('loadMoreProducts()');
		if(enablePerformanceMarks) performance.mark("loadMoreStart");

		// Total records displayed per page.
		var resultPerPage = parseInt( $('.products-per-page-js').val());
		// Total records displayed so far.
		var totalLoaded = ((pagesLoaded + 1) * resultPerPage);
		// Search Result count returned from server matching the search query.
		var totalReturned = $('.total-count-js').val();
		// Get the current number of product blocks on the page
		var beginIndex = $('.product-block-js').length;

		var categoryType = utils.getParamFromHash('category_type');
		var categoryTypePresence = utils.getURLParam(URL, 'category_type');
		var shouldAddCategoryType = categoryType.length > 0  && categoryType[0] !== '' && !categoryTypePresence;

		if (((beginIndex < totalReturned) && (totalLoaded < totalReturned) && !processing) || (shouldAddCategoryType && totalReturned === 0)){
			processing = true;
			lockLazyLoadAjax = true;

			if (!isPartialLoad) {
				pagesLoaded++;
			}

            if (optimizeRequestsEnabled) {
                URL = getURLWithPageSize(URL, pages);
            }

			if(pageSizeByDeviceEnabled){
				URL = utils.setURLParam (URL, 'pageSize', $('.products-per-page-js').val());
			}
			if(beginIndex > 0 && $('.COMPONENT-ESPOT-CATEGORY-BANNER').length == 1)
			{
				beginIndex++;
			}
			URL = utils.setURLParam (URL, 'beginIndex', beginIndex);
			if ($('body').hasClass('search') && isEASearchTemplate) {

				var orderBy = history.state ? history.state.orderBy : utils.getParamFromHash('orderBy');

				if(!isSimpleFacetEnabled){
					URL = utils.setURLParam (URL, 'requestData', 'next');
					var catPath = $('.ajax-product-search-js').data('catPath');

					if (URL.indexOf('catPath') > -1) {
						URL = utils.removeURLParam(URL,'catPath');
					}
					URL = utils.setURLParam (URL, 'catPath', catPath);
				}

				if (orderBy && orderBy !== '-1') {
					URL = utils.setURLParam(URL, 'orderBy', orderBy);
				}
			}

			URL = utils.removeURLParam (URL, 'returnProductsOnly');		//<--Temp fix for daisy chained design flaw
			$('.ajax-product-search-js').data('value', URL);

			//This line of code is problematic.  It interferes with facets if loadMoreProducts is daisy chained. Fix added above
			URL = utils.setURLParam (URL, 'returnProductsOnly', 'true');

			var banner = utils.getParamFromHash('banner');
			var bannerPresence = utils.getURLParam(URL, 'banner');
			if(banner.length > 0  && banner[0] !== '' && !bannerPresence){
				URL += "&banner=" + banner;
			}

			if (shouldAddCategoryType) {
				URL += "&category_type=" + categoryType;
			}

			var pageUrlPresence = utils.getURLParam(URL, 'pageUrl');
			if(!pageUrlPresence){
				URL += "&pageUrl=" + encodeURIComponent(utils.getFullUrl());
			}

			fetchProducts (URL, "LOAD-MORE-RESULTS", pages, showLoadingNotification, isPartialLoad);
			$('.view-more-results-js').remove ();

			$.pubsub('publish', 'vfdp.wcs.product_list.ajax_product_load', {beginIndex: beginIndex});
		}

	}

	function getPageSizeForDevice(){
		if(DEBUG) console.log('getPageSizeForDevice()');

		if(screenSize.size() === 'small')
			return WCS_CONFIG.get('grid::pageSizeForMobile');
		else if(screenSize.size() === 'medium')
			return WCS_CONFIG.get('grid::pageSizeForTablet');
		else return WCS_CONFIG.get('grid::pageSizeForDesktop');

	}

    function getURLWithPageSize(URL, pages) {
        var pageSize = $('.products-per-page-js').val();

        if (pageSizeByDeviceEnabled) {
            if (pages > 1) {
                URL = utils.setURLParam(URL, 'pageSize', getPageSizeForDevice() * pages);
            } else {
                URL = utils.setURLParam(URL, 'pageSize', pageSize);
            }
        } else {
            pageSize = pages > 0 ? pages * pageSize : pageSize;
            URL = utils.setURLParam(URL, 'pageSize', pageSize);
        }
        return URL;
    }

	function _toggleLazyLoading(){
		if(DEBUG) console.log('_toggleLazyLoading()');
		autoEnableLazyLoad = $('.auto-enable-lazy-load-js').val();
		if (autoEnableLazyLoad === 'true') {
			enableLazyLoad = true;
		}
	}

	//This function collapses a filter provided as an argument
	function _collapseFilter(filter) {
		if(DEBUG) console.log('_collapseFilter()');
		filter.classList.add('collapsed');
	}

	//This function collapses all filters without a selection
    function _collapseUnusedFilters() {
        if (DEBUG) console.log('_collapseUnusedFilters()');
        if (productListUnusedFiltersStartCollapsed[screenSize.size()]) {
            var allFilters = document.querySelectorAll('.filters-nav .filter-group');
            for (var i = 0; i < allFilters.length; i++) {
                if (!allFilters[i].classList.contains('selected') && !allFilters[i].classList.contains('collapsed')) {
                    _collapseFilter(allFilters[i]);
                }
            }
        }
    }

	// Modify product's images in fetchProduct Response
	function updateProductImgOnDataResponse($container) {
		if(!isGridLayoutImagePresetsEnabled) {
			return;
		}
		if(DEBUG) console.log('updateProductImgOnDataResponse()', $container);

		var s7PresetToUse = productView.getS7PresetWithScreenSize();
		var productImgList = $($container).find('.product-block-views-selected-view-main-image');

		if(productImgList.length > 0) {
			productImgList.each(function () {
				var $item = $(this);
				$item = productView.updateImgWithS7Preset($item, s7PresetToUse);
			});
		}
		return $container;
	}

	//This will return products, filters, and breadcrumbs
	function fetchProducts(URL, type, pages, showLoadingNotification, isPartialFetch){
		if(DEBUG) console.log('fetchProducts() type: ', type);
		type = type || "LOAD-MORE-RESULTS";
		if (WCS_CONFIG.get('global::useCustomLoadingNotification')) {
			$('.facet-product-counter').addClass('fetching-porducts');
			$('.active-filters-container .product-info').addClass('fetching-products');
		} else if(WCS_CONFIG.get('grid::showLoadingNotification') || showLoadingNotification){
			alertIndicator.showLoadingNotification();
		}

		if(enablePerformanceMarks && facetClickDetected) {
			performance.mark("filterStart_FromClick");
        }

		$('.page-messaging-js').remove();

		prevURL = URL;
		$.ajax({
			url: URL,
			type: 'GET',
			traditional: true,
			success: function (data){

				var gridOffset = 0;
				var $resultsContainer = null;

				if (type === "LOAD-MORE-RESULTS"){
					if(DEBUG) console.log('LOAD-MORE-RESULTS');
					if(EVENT_DEBUG) console.log('SUCCESS AJAX EVENT 1');
					$resultsContainer = $('#FSMLazyLoadContainer').length == 1 ? $('#FSMLazyLoadContainer') : $('.catalog-results-js');
					var	$responseContainer = $('<div>').html (data.products);
					if(isGridLayoutImagePresetsEnabled) {
						$responseContainer = updateProductImgOnDataResponse($responseContainer);
					}
					gridOffset = $resultsContainer.find('.product-block-js').length;
					$resultsContainer.append ($responseContainer.find ('.product-block-js'));
					processing = false;

					$.pubsub('publish','PRODUCT_LIST_REFRESH');
				}

				//FILTER RESULTS
				else{
					if(EVENT_DEBUG) console.log('SUCCESS AJAX EVENT 2');
					$resultsContainer = $('.product-listing-js');
					var	$filtersContainer = $('.filters-nav-js'),
						$breadcrumb = $('.product-list-search-top-js'),
						$summary = $('<div>'),
						$facetsBtn = $('.facets-btn-js'),
						$catalogForm = $('#catalog-form'),
						$showHideSelectedFacetsContainer = $('.show-hide-selected-facets-container');

					if ($catalogForm.length > 0) {
						$resultsContainer = $catalogForm;
					}

					if (data.searchSummary){
						if(EVENT_DEBUG) console.log('SUCCESS AJAX EVENT 2a');
						$summary.html (data.searchSummary);
						$breadcrumb.find ('.search-results-summary-js').html ($summary.find ('.search-results-summary-js').html ());
					}
					else{
						if(EVENT_DEBUG) console.log('SUCCESS AJAX EVENT 2b');
						$summary.html (data.categorySummary);
						$breadcrumb.find ('.no-header-hero-js').html ($summary.find ('.no-header-hero-js').html ());
						if (WCS_CONFIG.get('grid::displayCountOnlyOnProductFinder') && $('.product-finder-active').length > 0) {
							var $headerContent = $('.product-finder-footer-panel');
							$headerContent.find('.header-result-counter-number').html($summary.find('.header-result-counter-number').html());
							$headerContent.find('.header-result-counter-number').removeClass('hide');
						}
					}

					if (!$facetsBtn.parent().hasClass('collapsed')){
						if(EVENT_DEBUG) console.log('SUCCESS AJAX EVENT 2c');
						$facetsBtn.trigger('click');
					}

					if ( !WCS_CONFIG.get('HandleBarsModules::TopBarFacets') ) {
						if(EVENT_DEBUG) console.log('SUCCESS AJAX EVENT 2d');
						$breadcrumb.find('.breadcrumb-selected-facet-js').html(data.selectedFilters);
						if(WCS_CONFIG.get('grid::plpShowSelectedFacetsCountEnabled') && $('.product-list-refine-search-container .filter-search-btn-js .label-number-active-facets').length > 0) {
							var activeFilters = $(".product-list-grid-header .breadcrumb-selected-facet-js .breadcrumb-facet-list .breadcrumb-facet").length;
							var activeFiltersText = $(".product-list-refine-search-container .filter-search-btn-js .label-number-active-facets")
							activeFilters > 0 ? activeFiltersText.text("(" + activeFilters + ")") : activeFiltersText.text("");
						}
					}

					if ( WCS_CONFIG.get('HandleBarsModules::TopBarFacets') && ( !plpTopNavDesktopEnabled && (screenSize.size() == 'large') || screenSize.size() == 'xlarge')) {
						if(EVENT_DEBUG) console.log('SUCCESS AJAX EVENT 2d');
						$showHideSelectedFacetsContainer.find('.selected-facets-container').html(data.selectedFilters);
						var $showMoreOptionsSelector = $showHideSelectedFacetsContainer.find('.selected-facets-container .show-options');
						if ( $showMoreOptionsSelector.length > 0 && !$showMoreOptionsSelector.hasClass('less') && !isShowMoreVisible) {
							$showMoreOptionsSelector.trigger('click');
						}
					}

					if(type !== "REFRESH-FILTERS")
						if(EVENT_DEBUG) console.log('SUCCESS AJAX EVENT 2e');
						$resultsContainer.html(data.products);

					if(isGridLayoutImagePresetsEnabled) {
						$resultsContainer = updateProductImgOnDataResponse($resultsContainer);
					}

					$filtersContainer.html (data.filters); // This line re-inserts the filter groups' html, negating previous collapsing of filters
					if($filtersContainer.find('.filter-group.selected.reset-all').length > 0){
						if(EVENT_DEBUG) console.log('SUCCESS AJAX EVENT 2f');
						$filtersContainer.find('.filter-group.selected.reset-all').clone().prependTo('#filters-nav');
						$filtersContainer.find('.filter-group.selected.reset-all').first().removeClass('hide');
					}

					if(leftNavFilterDesktopWithMobileModal) {
						var $colorFacetsSelector = $('.filter-group.color-family .facet-value');
						for (var i = 0; i < $colorFacetsSelector.length; i++) {
							var $colorFacetElement = $($colorFacetsSelector[i]).find('.facet-color.checked');
							var rgbBackground = $colorFacetElement.css("background-color");
							var hexColor = getHexColorFromRGB(rgbBackground);
							if (hexColor.includes('#')) {
								var betterColor = utils.compareContrast(hexColor, lightCheckMarkColor, darkCheckMarkColor);
								if (betterColor === darkCheckMarkColor) {
									$colorFacetElement.addClass('inverse-selection-check-color');
								}
							}
						}
					}
					var totalCount = $('.total-count-js').val();

					$('.product-count-js').html(totalCount);

					if (totalCount == "0") {
						handleZeroResults();
					}

					if (plpFiltersAndSortBtnEnabled && screenSize.size() === 'small') {
						handleSortSelection();
					}
				}

				initProductList($resultsContainer);
				var $productBlocks = $('.product-block-js');
				if($('.search-group-js').length > 0){
					if(EVENT_DEBUG) console.log('SUCCESS AJAX EVENT 3');
					$productBlocks.each(function (i){
						var n = i + 1;
						$(this).addClass('product-' + n);
					});
				}
				if ($($productBlocks.get(0)).find('.color-swatches-js').length > 0){
					if(EVENT_DEBUG) console.log('SUCCESS AJAX EVENT 4');
					var beginIndex = parseInt (utils.getURLParam( $('.ajax-product-search-js').data('value'), 'beginIndex'));
					if (beginIndex > 0){
						if(EVENT_DEBUG) console.log('SUCCESS AJAX EVENT 4a');
						$productBlocks = $productBlocks.slice(beginIndex);
						productView.initHoverOnProductBlock ($productBlocks);
					}
				}
				//setup height for each product block after all images are loaded
				productGrid.initializeSetHeight();
				productView.initProductBlockRolloverFunctionality();
				productView.initMoreSwatches ();

				$.pubsub('publish', 'PLP.FETCHIMAGES_AJAX.DONE');

				_toggleLazyLoading();

				if (!WCS_CONFIG.get('ATTRAQT::ENABLED')) {
					if(EVENT_DEBUG) console.log('SUCCESS AJAX EVENT 5');
					facets = utils.getParamFromHash('facet');
					filterValues = [];
					filterCategories = [];
					if (facets && facets.length > 0) {
						filters = parseFacetParam(facets.split(','));
						filterValues = filters.filterValues;
						filterCategories = filters.filterCategories;
					}
		            $.pubsub('publishSync', 'vfdp.wcs.product_list.ajax_product_loaded', {gridOffset: gridOffset, filterCategories: filterCategories, filterValues: filterValues});
                }

				if(isPartialFetch && pages === 0){	//VFDP-23111: Is this the last of the series of partial page fetches?
					if(EVENT_DEBUG) console.log('SUCCESS AJAX EVENT 6');
					var initialPageSize = $('.products-per-page-js').val();
					var pageSizeForDevice = getPageSizeForDevice();

					if(initialPageSize < pageSizeForDevice){	//Device page size is different than initial load.  Prepare for full page fetch...
						if(EVENT_DEBUG) console.log('SUCCESS AJAX EVENT 6a');
						$('.products-per-page-js').val(pageSizeForDevice);
						var revisedURL = $('.ajax-product-search-js').data('value');
						revisedURL = utils.setURLParam (revisedURL, 'beginIndex', 0);
						revisedURL = utils.setURLParam (revisedURL, 'pageSize', pageSizeForDevice);
						$('.ajax-product-search-js').data('value', revisedURL);
					}

					$.pubsub('publish', 'vfdp.wcs.product_list.ajax_partial_product_load_complete');
				}

				//VFDP-31108: Final followup request is needed to insure unfiltered OOS products not included in filter prod count
				if( !$('body.search').length && !isPartialFetch && pages === 0 && !WCS_CONFIG.get("grid::unfilteredSearchInventorySensitive") && type !== "REFRESH-FILTERS" && !WCS_CONFIG.get('HandleBarsModules::TopBarFacets')){
					if(EVENT_DEBUG) console.log('SUCCESS AJAX EVENT 7');
					var URL = $('.ajax-product-search-js').data('value');

					if(utils.getURLParam(URL, 'facet') === 0){
						if(EVENT_DEBUG) console.log('SUCCESS AJAX EVENT 7a');
						URL = utils.setURLParam(URL, 'facet', "");	//pass facet to exclude OOS
						fetchProducts(URL, "REFRESH-FILTERS", 0, showLoadingNotification, false);
					}
				}

				_setActiveFiltersAfterHashChange();
                _addFilterCloseButtonEventHandler();

				//Unused filters start in collapsed state when there are filters with selection
				_collapseUnusedFilters();

                pluginLoader.runVFDPPlugins($resultsContainer);

                //SETTING PERFORMANCE MARK HERE because of ALL OF THE IF CONDITIONS ABOVE, 2a-2f (thats 6 conditions) all get called so not sure where to place the mark
                if(enablePerformanceMarks && facetClickDetected && BOOMRavailable) {
					facetClickDetected = false;

					performance.mark("facetsLoaded_FromClick");
					var facetsLoaded_FromClickMark = performance.getEntriesByName("facetsLoaded_FromClick")[0];
					performance.mark("filterStop");
					var filterStopMark = performance.getEntriesByName("filterStop")[0];
                	performance.measure("filterTime", "filterStart", "filterStop");
					var filterTimeMeasure = performance.getEntriesByName("filterTime")[0];

                	BOOMR.sendTimers({
                	  "facetsLoaded_FromClick": facetsLoaded_FromClickMark.startTime,
                	  "filterStop": filterStopMark.startTime,
                	  "filterTime": filterTimeMeasure.duration
                	});
                }

                if(type === "LOAD-MORE-RESULTS" && enablePerformanceMarks && BOOMRavailable) {
                	performance.mark("loadMoreStop");
                	var loadMoreStopMark = performance.getEntriesByName("loadMoreStop")[0];
                	performance.measure("loadMoreTime", "loadMoreStart", "loadMoreStop");
                	var loadMoreTimeMeasure = performance.getEntriesByName("loadMoreTime")[0];
                	BOOMR.sendTimers({
                	  "loadMoreStop": loadMoreStopMark.startTime,
                	  "loadMoreTime": loadMoreTimeMeasure.duration
                	});

                }

			},
			error: function () {
				if(EVENT_DEBUG) console.log('ERROR AJAX EVENT 1');
				var errorMessage = '<section class="page-messaging page-messaging-js"><div><p class="message error">' + productListErrorMessage + '</p></div></section>';

				if (type === "LOAD-MORE-RESULTS") {
					if(EVENT_DEBUG) console.log('ERROR AJAX EVENT 2');
					$('.catalog-container-js').append(errorMessage);
				} else {
					if(EVENT_DEBUG) console.log('ERROR AJAX EVENT 2a');
					$('.product-list-js').prepend(errorMessage);
					$('html, body').scrollTop( $('.page-messaging-js').offset().top);
				}
			}
		}).always(function() {
			if(EVENT_DEBUG) console.log('ALWAYS AJAX EVENT');
			if (WCS_CONFIG.get('global::useCustomLoadingNotification')) {
				$.pubsub('publish', 'vfdp.wcs.product_list.ajax_product_load_complete');
				$('.facet-product-counter').removeClass('fetching-porducts');
				$('.active-filters-container .product-info').removeClass('fetching-products');
			} else if(WCS_CONFIG.get('grid::showLoadingNotification') || showLoadingNotification){
				if(EVENT_DEBUG) console.log('ALWAYS AJAX EVENT 1');
				alertIndicator.hideLoadingNotification();

				// Once we have all of the data in place, then restore scroll position
				restoreScrollPosition();
			}

			if (pages > 0 && !optimizeRequestsEnabled) {
				if(EVENT_DEBUG) console.log('ALWAYS AJAX EVENT 2');
                loadMoreProducts(URL, pages - 1, false, isPartialFetch);
			}

			disallowScroll = false;

			setFilterActionButtons();
			if(displayLoadMoreButton === true) {
				if(EVENT_DEBUG) console.log('ALWAYS AJAX EVENT 3');
				toggleLoadMoreButtonDisplay();
			}

			_addClassToAttribute();
		});
	}

	function restoreScrollPosition() {
		var clickedProductCookie = context.getCookie(clickedProductCookieName);

		if (clickedProductCookie) {
			var clickedProductObj = JSON.parse(clickedProductCookie);
			var $clickedProduct = $('[data-part-number="' + clickedProductObj.partNumber + '"]'),
					scrollPosition = clickedProductObj.scrollPosition;

			// Wait for element to be on the page then restore scroll position
			utils.elementLoaded($clickedProduct, function($el) {
				window.scrollTo(0, scrollPosition);
				context.removeCookie(clickedProductCookieName);
			});
		}
	}

	function handleSortSelection(){
		if (DEBUG) console.log('handleSortSelection()');
		try {
			var orderBy = history.state ? history.state.orderBy : utils.getParamFromHash('orderBy');
			var inpList = $('.product_sort_radio_select');
			// removing default check and adding active to selected checkbox
			for (var ac = 0; ac < inpList.length; ac++) {
				var $checkedElement = $(inpList[ac]);
				var val = $checkedElement.val() || '-1';
				if (val === orderBy) {
					$checkedElement.prop('checked', true);
					$checkedElement.addClass('active');
				} else {
					$checkedElement.prop('checked', false);
					$checkedElement.removeClass('active');
				}
			}
		} catch(e) {
			console.log(e);
		}
	}

	function _addClassToAttribute(){
		if(DEBUG) console.log('_addClassToAttribute()');
		var charLength = 4,
			$attribute = $('.filter-options li.attr-box'),
			classToAdd = 'attr-box-center';

		$attribute.each(function() {
			if($(this).html().length > charLength) {
		  		$(this).addClass(classToAdd);
	 	 	}
		});
		setFacetCollapse(facetAfterCollapse);
	}

	function updateSortByValue(value){
		if(DEBUG) console.log('updateSortByValue()');
		if (value > 0){
			$('.sort-by-btn-js').each(function (){
				var $this = $(this),
					$sortByLabel = $this.find('.selected-sort-by-js'),
					$sortByOptions = $this.find('.sort-by-option-js'),
					labelValue = '';

				$sortByOptions.each(function (){
					var $option = $(this);

					if ($option.data('value') === parseInt(value, 10)){
						labelValue = $option.text();
					}
				});

				$sortByLabel.text(labelValue);
			});
		}
	}

	function sortByOnClick($target, orderBy) {
		if(DEBUG) console.log('sortByOnClick()');

		// If we are using the sort.hbs we dont need to enter here since the facets-controller will handle the sorting
		if ($target.closest('.sub-menu-options').length) {
			return;
		}

		var value = $target ? $target.data('value') || $target.val() : orderBy,
			category = utils.getURLParam ( $('.ajax-product-search-js').data('value'), 'categoryId'),
			path = $('.ajax-product-search-js').data('catPath'),
			state;

		if($target) {
			var $this = $target,
				$parent = $($this.parents('.dd-select-js').eq(0)),
				labelValue = $this.text();
			$parent.find('.selected-sort-by-js').text(labelValue);
		}

		if(isNaN(parseInt(value))) {
			value = "-1";
		}

		if($('body').hasClass('search') && isEASearchTemplate && !isSimpleFacetEnabled) {
			state = {orderBy: value, catPath: path, beginIndex: 0, requestData: 'first'};
		} else {
			state = {orderBy: value, beginIndex: 0, categoryId: category};
		}

		history.replaceState(state, null, utils.setMultipleURLParams(state, true));
	}

    function initSetupFacetUrlSearch() {
    	if(DEBUG) console.log("initSetupFacetUrlSearch()");

        if (window.location.hash.length > 0 && utils.getHash().indexOf('facet') > -1) {
            if (utils.removeHash().indexOf('facet') > -1 || (plpFacetFiltersRemoveDuplicateUrlEnabled && utils.getHash().indexOf('facet') > -1)) {
            	if(DEBUG) console.log("filterProductsOnPageLoad");
            	if(enablePerformanceMarks) {
            		filteringFacetsOnPageLoadDetected = true;
            		performance.mark("filterProductsFromDeepLinkStart");
            	}

                filterProductsOnPageLoad = true;
            } else {
            	if(DEBUG) console.log("history.replaceState");
                history.replaceState(null, null, utils.setMultipleURLParamsFromHash());
            }
        }
    }

	function activeFacetToggle(facetContainerHeight, f_height) {
		if (facetContainerHeight > f_height) {
			$('.breadcrumb-facet-list').addClass('collapsed');
			$('.active-facet-toggle').show();
			$('.active-facet-toggle-more').show();
			$('.active-facet-toggle-less').hide();
		}
		else {
			$('.breadcrumb-facet-list').removeClass('collapsed');
			$('.active-facet-toggle').hide();
			$('.active-facet-toggle-more').hide();
			$('.active-facet-toggle-less').show();
		}
	}

	function updateFacetView() {
		if(plpFiltersAndSortBtnEnabled) {
			if ( DEBUG ) console.log('updateFacetView');
			try {
				var facetContainerHeight = $('.page-contents .breadcrumb-facet-list').innerHeight();
				if(screenSize.size() === "small") {
					activeFacetToggle(facetContainerHeight, toggleFilterValues.mobileHeight);
				} else {
					activeFacetToggle(facetContainerHeight, toggleFilterValues.desktopHeight);
				}
			} catch(e){
				console.error(e)
			}

			$('.active-facet-toggle-more, .active-facet-toggle-less').on('click', function() {
				if ( DEBUG ) console.log('active-facet-toggle-');
				if ($('.breadcrumb-facet-list').hasClass('collapsed')){
					$('.active-facet-toggle-more').hide();
					$('.active-facet-toggle-less').show();
				} else {
					$('.active-facet-toggle-less').hide();
					$('.active-facet-toggle-more').show();
				}
				$('.breadcrumb-facet-list').toggleClass('collapsed');
			});
		}
	}


	function toggleApplyBtnText(activeFacets) {
		if(plpFiltersAndSortBtnEnabled) {
			if(!activeFacets) {
				activeFacets =  utils.getParamFromHash('facet') ? utils.getParamFromHash('facet').split(',') : [];
			}
			if(activeFacets && activeFacets.length > 0) {
				$('.apply-filter-js').text(toggleFilterValues.applyFilters).removeClass('view-all-filters');
				$('.facet-clear-all').addClass('show_clear_all');
			} else {
				$('.apply-filter-js').text(toggleFilterValues.viewAllFilters).addClass('view-all-filters');
				$('.facet-clear-all').removeClass('show_clear_all');
			}
		}
	}

	function initProductList($container) {
		if(DEBUG) console.log('initProductList()');
		totalResults = parseInt($('.total-count-js').val());
		var currentURL = window.location.href;
		main.update();
		toggleApplyBtnText(null);
		updateFacetView();
		//reset sort box
		var sortByValue = utils.getURLParam(currentURL, 'orderBy');
		if(sortByValue <= 0) {
			sortByValue=null;
		}else{
			$(".sort-by-js option[value=\'" + sortByValue +"\']").prop('selected', 'selected').trigger('updateSkin');
		}

		updateSortByValue(sortByValue);

		if (($container.hasClass ('catalog-results-js') || $container.attr('id') === 'FSMLazyLoadContainer') && $container.not('.search-group-js')){
			lockLazyLoadAjax = false;
			enableLazyLoad = true;
		}

		$('.options-js .show-articles-js').on('change', function() {
		  window.location.href = $(this).val();
		});
	}

	function filterProducts(pages, isPartialFilter){
		if(DEBUG) console.log('filterProducts', pages, isPartialFilter);
		if(enablePerformanceMarks) performance.mark("filterStart");

		var $body = $('body'),
			URL = $('.ajax-product-search-js').data('value') || prevURL || '',
            facets = history.state && history.state.facet ? history.state.facet : utils.getParamFromHash('facet').split(','),
			banner = utils.getParamFromHash('banner'),
			categoryType = utils.getParamFromHash('category_type'),
			beginIndex = history.state && history.state.beginIndex ? history.state.beginIndex : utils.getParamFromHash('beginIndex') || 0,
			orderBy = history.state && history.state.orderBy ? history.state.orderBy : utils.getParamFromHash('orderBy'),
			categoryId = utils.getURLParam(URL, 'categoryId'),
			searchSource = utils.getURLParam(URL, 'searchSource');

		URL = removeFacetsFromURL(URL);
		URL = utils.setURLParam(URL, 'searchSource', searchSource);
		URL = utils.setURLParam(URL, 'beginIndex', beginIndex);
		facetAfterCollapse = getFacetCollapse();

		if(pageSizeByDeviceEnabled){
			URL = utils.setURLParam (URL, 'pageSize', $('.products-per-page-js').val());
		}

		if ($body.hasClass('lanes') && !$body.hasClass('no-lanes')){
			$body.addClass('no-lanes');
		}

		if ($body.hasClass('search') && isEASearchTemplate && !isSimpleFacetEnabled){
			var catPath,
				requestData;

			if(history.state && history.state.catPath) {
				catPath = history.state.catPath;
			} else if(utils.getParamFromHash('catPath')) {
				catPath = utils.getParamFromHash('catPath');
			} else {
				catPath = $('.ajax-product-search-js').data('catPath');
			}

			if(history.state && history.state.requestData) {
				requestData = history.state.requestData;
			} else if(utils.getParamFromHash('requestData')) {
				requestData = utils.getParamFromHash('requestData');
			} else {
				requestData = $('.ajax-product-search-js').data('requestAction') || 'CA_BreadcrumbClick';
			}

			if (URL.indexOf('catPath') > -1) {
				URL = utils.removeURLParam(URL,'catPath');
            }
			URL = utils.setURLParam(URL, 'catPath', catPath);
			URL = utils.setURLParam(URL, 'requestData', requestData);
			if($('.facets-bar').length > 0){
				URL = utils.setURLParam(URL, 'navType', 'topNav');
			}
		}

		pagesLoaded = 0;

		if(categoryId)
			URL = utils.setURLParam(URL, 'categoryId', categoryId);

		if (orderBy) {
			// fetchProducts must be forced to true since if the default sort option (empty in the mark-up and -1 in the script) is selected
			// it should not be passed in the ajax url. But if no orderby paramenter is detected in the ajax url, the ajax call is not triggered.
            if (orderBy === '-1') {
                doFetchProducts = true;
                URL = utils.removeURLParam(URL,'orderBy');
            } else {
            	URL = utils.setURLParam(URL, 'orderBy', orderBy);
			}
		} else if (!orderBy || (!isEASearchTemplate && !isBRSearchTemplate)) {
			URL = utils.removeURLParam(decodeURIComponent(URL), 'orderBy');
		}
		facetList = [];

		// sort facet to avoid multiple cache entries for same facet
		if (facets.length > 1) {
			facets = utils.sortFacetParam(facets);
		}

		var facetIds = [];
		if(facets.length > 0  && facets[0] !== ''){
			$.each(facets, function(index, value){
				URL += "&facet=" + value;
				var facetValue = isBRSearchTemplate && facetDecodingEnabled ? decodeURIComponent(value) : value;
				facetList = updateFacetList(facetValue, facetList);
				if ( plpAddFacetidFieldAnalytics ) {
					var currentFacetId = $('button[data-facet-value="'+facetValue+'"]').parents('.filter-group'),
						currentFacetLabel = currentFacetId.data('facet-id');
					facetIds.push(currentFacetLabel);
				}
			});
			if (WCS_CONFIG.global.fredHopperEnabled && (!WCS_CONFIG.get('HandleBarsModules::TopBarFacets') || leftNavFilterDesktopWithMobileModal) && facetList.length) {
				filterValues = [];
				filterCategories = [];
				if (facetList && facetList.length > 0) {
					filters = parseFacetParam(facetList);
					filterValues = filters.filterValues;
					filterCategories = filters.filterCategories;
				}
				var jsonAnalyticsObject = {eventLabel: 'Apply', filterCategories: filterCategories, filterValues: filterValues};
				if ( plpAddFacetidFieldAnalytics ) {
					jsonAnalyticsObject = {eventLabel: 'Apply', filterCategories: filterCategories, filterValues: filterValues, facetIds: facetIds};
				}
				$.pubsub('publish', 'vfdp.wcs.product_list.FILTERS_CHANGED', jsonAnalyticsObject);
			}
		}

		if(banner.length > 0  && banner[0] !== ''){
			URL += "&banner=" + banner;
		}

		if (categoryType.length > 0  && categoryType[0] !== '') {
			URL += "&category_type=" + categoryType;
		}
		URL += "&pageUrl=" + encodeURIComponent(utils.getFullUrl());


        // on resetting filters, only if the page has swim lanes must be reloaded; the rest
        // of the cases can rely on a standard (all inclusive) ajax call
        if ($body.hasClass('cat-lanes-js') && doResetFilters) {
            doResetFilters = false;
            window.location.href = utils.getBaseUrl();
            return false;
        } else if (utils.getURLParam(URL, 'facet') !== 0 || utils.getURLParam(URL, 'banner') !== 0 || utils.getURLParam(URL, 'orderBy') !== 0 || utils.getURLParam(URL, 'category_type') !== 0 || doFetchProducts)  {
            doFetchProducts = false;
            doResetFilters = false;
            fetchProducts(URL, "FILTER", pages, false, isPartialFilter);
        }

        doResetFilters = false;
        disallowScroll = false;
	}

	function parseFacetParam(facetList) {
		filterIds = [];
		filterValues = [];

		facetList.forEach(function(facet){
			// the values are received from BE encoded twice
			if (facet.includes(encodeURI('%3D')) ||
				(facet.includes(encodeURI("%7B")) &&
				facet.includes(encodeURI("%7D")) &&
				(facet.includes(encodeURI("%3C")) || facet.includes(encodeURI("%3E"))))) {
					facetString = decodeURI(facet)
						.replace("%7B", "")
						.replace("%7D", "");
					facetKeyValuePair = [];
					if (facetString.includes('%3D')) {
						facetKeyValuePair = facetString.split('%3D');
					} else if (facetString.includes('%3E')) {
						facetKeyValuePair = facetString.split('%3E');
					} else {
						facetKeyValuePair = facetString.split('%3C');
					}

					if (facetKeyValuePair.length > 1) {
						if (facetKeyValuePair[1].startsWith(facetKeyValuePair[0] + "_")) {
							facetKeyValuePair[1] = facetKeyValuePair[1].replace(facetKeyValuePair[0] + "_", "");
						}
						facetElement = $("[data-filter-option='" + facet + "']");
						if (facetElement && facetElement.length > 0) {
							filterName = facetElement[0].getAttribute('data-filter-name');
							if (filterName) {
								facetKeyValuePair[1] = filterName;
							}
						}
						filterIds.push(facetKeyValuePair[0]);
						filterValues.push(facetKeyValuePair[1]);
					}
			}
		});
		return {filterCategories: filterIds, filterValues: filterValues};
	}

	function handleZeroResults() {
		if(DEBUG) console.log('handleZeroResults');
		var $productFinder = $('.product-finder'),
				$selectedFilters = $productFinder.find('.switched-on'),
				facetsValue,
				facetsArray = [];

		$selectedFilters.each(function(index, filter) {
			var stepNumber = $(filter).closest('.product-finder-step').data('product-finder-page'),
					stepLabel,
					facets = $(filter).data('facets'),
					facetData = facets[0],
					facetAttribute = facetData.attribute;

			// Replace step number with actual facet category
			switch (stepNumber) {
				case 0:
					stepLabel = 'Color: ';
					break;
				case 1:
					stepLabel = 'Type: ';
					break;
				case 2:
					stepLabel = 'Size: ';
					break;
				default:
					stepLabel = '';
					break;
			}

			// Push to array step and facet value (Color: Blue)
			facetsArray.push(stepLabel + facetAttribute);
		});

		facetsValue = facetsArray.join(' | ');

		try {
			var obj = {
				"event": "loadEventData",
				"eventCategory": "PLP",
				"eventAction": "Product Finder",
				"eventLabel": "Zero Results",
				"nonInteractive": false,
				"customVariables": {
					"filterValue": facetsValue
				}
			};

			if(DEBUG) console.log('dataLayer | Push', obj);
			window.dataLayer.push(obj);
		} catch (err) {
			console.error('dataLayer | Something went wrong', err);
		}
	}

	function _setActiveFiltersAfterHashChange () {
		if(DEBUG) console.log('_setActiveFiltersAfterHashChange');
		var $allFacets = $('.filters-nav-js').find('.facet-option-js'),
			$appliedFacets = $('.breadcrumb-selected-facet-js').find('.facet-option-js'),
			facetValues = [];

		$appliedFacets.each(function(i, appliedFacet){
			facetValues.push($(appliedFacet).data('facetValue'));
		});

		facetValues.forEach(function(facetValue){
			$allFacets.each(function(i, facet){
				if( $(facet).data('value') === facetValue ) {
					$(facet).find('.centering-container').addClass('selected');
				}
			});
		});

	}

	function _addFilterCloseButtonEventHandler() {
        if(DEBUG) console.log('_addFilterCloseButtonEventHandler()');
        //trigger filter close button when clicked on the button which is inside filters-section-pannel.
        $(".filter-search-close-btn-js").off('click').on('click', function (event) {
            event.preventDefault();
            $('.filter-search-btn-js').trigger('click');
        });
    }

	function toggleLoadMoreButtonDisplay() {
        if(DEBUG) console.log('toggleLoadMoreButtonDisplay()');
        var pageSize = $('.products-per-page-js').val();
        if(pageSizeByDeviceEnabled) {
            pageSize = getPageSizeForDevice();
        }
		var $loadMoreButton =  $('.load-more-btn-js');
        var totalCount = $('.total-count-js').val();
        var currentCount = (pagesLoaded + 1) * parseInt(pageSize, 10);

		if ( currentCount < totalCount) {
			if (pageSizeRemainingNumberOnButtonEnabled) {
				var numberToShow = calculateRemainingToLoad(pageSize, currentCount, totalCount);
				updateRemainingOnLoadMoreButton($loadMoreButton, numberToShow);
			}
			$loadMoreButton.show();
		} else {
			$loadMoreButton.hide();
		}
	}

	function calculateRemainingToLoad(pageSize, currentCount, totalCount) {
		var numberToShow = pageSize;
		var remaining = totalCount - currentCount;
		if (pageSize > remaining) {
			numberToShow = remaining;
		}
		return numberToShow;
	}

	function updateRemainingOnLoadMoreButton($loadMoreButton, numberToShow){
		var text = $loadMoreButton.text();
		if( text.indexOf(loadMoreRemainingOpenBracket) === -1){
			$loadMoreButton.text(text + ' ' + loadMoreRemainingOpenBracket + numberToShow + loadMoreRemainingCloseBracket );
		}
		else {
			var textArray = text.split(loadMoreRemainingOpenBracket);
			$loadMoreButton.text(textArray[0] + ' ' + loadMoreRemainingOpenBracket + numberToShow + loadMoreRemainingCloseBracket);
		}
	}

	function setFilterActionButtons() {
		if(DEBUG) console.log('setFilterActionButtons()');
		var $actionContainer = $('.product-list-filters-action-js');

		if($actionContainer.length < 1) return;

		var offsetTop = $actionContainer.offset().top,
			containerHeight = $actionContainer.outerHeight(true),
			isFixed = $actionContainer.data('isFixed') ? $actionContainer.data('isFixed') : false;

		if($('.filter-search-btn-js').hasClass('filters-expanded')) {
			if(!isFixed) {
				if(offsetTop - $(document).scrollTop() > $(window).height() - containerHeight - 10) {
					$actionContainer.addClass("filters-action-fixed");
					$actionContainer.data('isFixed', true);
					$actionContainer.data('offsetTop', offsetTop);
				}
			} else {

				if($actionContainer.data('offsetTop') - $(document).scrollTop() <= $(window).height() - containerHeight - 10) {
					resetFilterActionButtons();
				}
			}
		} else {
			resetFilterActionButtons();
		}
	}

	function resetFilterActionButtons() {
		if(DEBUG) console.log('resetFilterActionButtons()');
		var $actionContainer = $('.product-list-filters-action-js');
		if($actionContainer.length < 1) return;
		$actionContainer.removeClass("filters-action-fixed");
		$actionContainer.data('isFixed', false);
		$actionContainer.data('offsetTop', '0');
	}

	function hidePromoContainersOnNonBundleEnabled () {
		if(DEBUG) console.log('hidePromoContainersOnNonBundleEnabled()');
		var $productBlock = $('.product-block-js');

		$productBlock.each(function(){

			var $this = $(this),
				$swatch = $this.find('.swatch-js.selected-js'),
				$thisEspotContainer = $this.find('.espot-container');

			if ( typeof $this.data('partNumber') === 'undefined' ){
				return;
			}

			if ( $swatch.length < 1 && typeof $this.data('hasPromo') === 'undefined' ){
				$thisEspotContainer.addClass('hide');
			}

			if ( !$swatch.data('hasPromo') && $swatch.length > 0 ){
				$thisEspotContainer.addClass('hide');
			}

		});
	}

	function customSortDropdown() {
		var originalSelect = $("#sort-by"); // Get the original select element
		var sortByWrapper = originalSelect.closest('.product-list-sort-by-section'); // Get the original select element's wrapper
		var customSelect = $("<div class='custom-sort-by'></div>"); // Create a custom select container
		var selectLabel = sortByWrapper.find('.prefix'); // Create a custom select container
		var customOptions = $("<div class='custom-sort-by-options'></div>"); // Create a custom options container

		customOptions.hide();

		sortByWrapper.addClass('custom-sort-by-section'); // mark the section as a one housing the custom dropdown

		// Create custom options based on the original select
		originalSelect.find("option").each(function () {
			var optionValue = $(this).attr("value");
			var optionText = $(this).text();
			var customOption = $("<div class='custom-sort-by-option'></div>");

			customOption.text(optionText);

			// Handle click event on the custom option
			customOption.on("click", function () {
				reloadFilters = true;
				var selectedValue = $(this).text();
				customSelect.find(".select-selected-sort-by-option").text(selectedValue);
				originalSelect.val(optionValue).change();
				customOptions.find(".custom-sort-by-option").removeClass("selected");
				$(this).addClass("selected");
			});
			
			customOptions.append(customOption);

			var customRadioButton = $("<div class='custom-sort-by-radio'><div class='custom-sort-by-radio-fill'></div></div>"); // Create a custom radio button element

			customOption.prepend(customRadioButton);
		});

		var customSelected = $("<div class='select-selected-sort-by-option'></div>"); // Create a custom selected element

		customSelected.text(originalSelect.find("option:selected").text());

		// Append elements to the custom select container
		customSelect.append(customSelected);
		sortByWrapper.append(customOptions);

		customSelect.on("click", function () {
			customOptions.toggle(0, function() {
				applyCustomSortClasses(sortByWrapper, customOptions.is(':visible'));
			});
		});

		selectLabel.on("click", function (e) {
			e.preventDefault();
			e.stopImmediatePropagation();
			customOptions.toggle(0, function() {
				applyCustomSortClasses(sortByWrapper, customOptions.is(':visible'));
			});
		});

		originalSelect.after(customSelect); // Append the custom select container to the form

		originalSelect.hide(); // Hide the original select

		// adding selected class for the default selected option			
		customOptions.find(".custom-sort-by-option:contains('" + customSelected.text() + "')").addClass("selected");

		// Handle clicks outside of the custom select
		$(document).on("click", function (event) {
			if (!$(event.target).closest(customSelect).length && !$(event.target).closest(selectLabel).length) {
				customOptions.hide(0, function() {
					applyCustomSortClasses(sortByWrapper, customOptions.is(':visible'));
				});
			}
		});
	}

	function applyCustomSortClasses($sortWrapper, isOpen) {
		if (isOpen) {
			$sortWrapper.addClass('custom-sort-by-open');
		} else {
			$sortWrapper.removeClass('custom-sort-by-open');
		}
	}

	function showHideFactesInitialize() {
		var $showHidefacetsButton = $("button.show-hide-facets-button");
		var $navDept = $("#nav-dept");
		var $catalogContainer = $("#catalog-container");
		
		if($showHidefacetsButton.length > 0) {
			$showHidefacetsButton.click(function(e) {
				e.preventDefault();
				e.stopPropagation();

				if(!$navDept.is(":visible")) {
					$navDept.removeClass("nav-dept-hidden");
					$catalogContainer.removeClass("catalog-container-full-width");
					$(e.currentTarget).parents('.show-hide-selected-facets-container').removeClass("show-hide-facets-button-clicked");
				} else {
					$navDept.addClass("nav-dept-hidden");
					$catalogContainer.addClass("catalog-container-full-width");
					$(e.currentTarget).parents('.show-hide-selected-facets-container').addClass("show-hide-facets-button-clicked");
				}
			})	
		}
	}

	function getHexColorFromRGB(rgb) {
		if (!rgb) {
			return '#FFFFFF'; //default color
		}
		var hex_rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/); 
		function hex(x) {return ("0" + parseInt(x).toString(16)).slice(-2);}
		if (hex_rgb) {
			return "#" + hex(hex_rgb[1]) + hex(hex_rgb[2]) + hex(hex_rgb[3]);
		} else {
			return rgb;
		}
	}

	//Initialize product-list page
	domReady(function(){
		if(DEBUG) console.log('domReady()');

		if (WCS_CONFIG.grid.productGridEnablePerformanceMarks) {
			performance.mark("Product Grid DOM ready");
		}

		//performance marks to indicate which search service is being employed
		if(enablePerformanceMarks && isEASearchTemplate) performance.mark("easyAsk");
		if(enablePerformanceMarks && isSimpleFacetEnabled) performance.mark("simpleFacets");
		if(enablePerformanceMarks && isBRSearchTemplate) performance.mark("bloomReach");
		if(enablePerformanceMarks && WCS_CONFIG.get('ATTRAQT::ENABLED')) performance.mark("attraqt");

		if (updatePlpLoyaltyCookie) {

			$.ajax({
				type: "GET",
				url: loyaltyCookieUrl,
				dataType: "json"
			}).done(function (data) {
				try {
					if (data && data.result && data.result.pb) {
						context.setCookie(loyaltyCookieName, data.result.pb);
					}
				} catch (exc) {
					console.error(exc);
				}

			}).fail(function (err) {
				console.error(err);
			});
		}


        var scrollPositionToken = $.pubsub('subscribe', 'vfdp.wcs.product_list.IMAGES_LOADED', function(event, data) {
            if (triggerScroll && scrollPosition > -1 && scrollPosition <= $(document).height()) {
                $(window).scrollTop(scrollPosition);
            }
			if($(document).height() > scrollPosition)
				$.pubsub('unsubscribe', scrollPositionToken);
        });

        $('.catalog-results-js').on('imageLoaded', function(){
            if(DEBUG) console.log('imageLoaded');
            productGrid.setHeight();
            $.pubsub('publish', 'vfdp.wcs.product_list.IMAGES_LOADED');

        });

        // this is meant for external components (doFetchProducts is global for this module)
        $.pubsub('subscribe', 'vfdp.wcs.product_list.RESET_FILTERS', function() {
            doFetchProducts = true;
            doResetFilters = true;
        });

        $.pubsub('subscribe', 'vfdp.wcs.product_list.FACETS_CHANGED', function() {
            doFetchProducts = true;
        });

		hidePromoContainersOnNonBundleEnabled();

		originalRequestAction = $('.ajax-product-search-js').data('catPath');
		facetList = []; 								//Maintain a stack of all facets selected

		//Call init all ui components
		productView.initialize();

		_addClassToAttribute();

		$(document).on('click', '.show-hide-selected-facets-container .show-options', function(event) {
			var $selectedFacetsSelector = $('.show-hide-selected-facets-container .selected-facets-container'),
				$showMoreLessSelected = $(event.currentTarget),
				moreClass = 'more',
				lessClass = 'less';
			$selectedFacetsSelector.toggleClass('expanded');
			if ($showMoreLessSelected.hasClass(moreClass)) {
				$showMoreLessSelected.removeClass(moreClass);
				$showMoreLessSelected.addClass(lessClass)
				$showMoreLessSelected.text($showMoreLessSelected.data('show-less-text'));
				$selectedFacetsSelector.find('.active-filters-list__active-filter.hide-more').removeClass('hide-more');
				isShowMoreVisible = false;
			} else if ($showMoreLessSelected.hasClass(lessClass)) {
				$showMoreLessSelected.removeClass(lessClass);
				$showMoreLessSelected.addClass(moreClass)
				$showMoreLessSelected.text($showMoreLessSelected.data('show-more-text'));
				$selectedFacetsSelector.find('.active-filters-list__active-filter:gt('+maxSelectedFacetsVisibleDesktop+') ').addClass('hide-more');
				isShowMoreVisible = true;
			}

		});

		// Reset all filters and update products
		$(document).on('click', '.reset-all-filters', function(event) {
				event.preventDefault();
				doFetchProducts = true;
				doResetFilters = true;
				reloadFilters = true;

				if ($('body').hasClass('search') && isEASearchTemplate) {
					var currentURL = $('.ajax-product-search-js').data('value');

					// Persist core URL params in order to search API work properly
					var state = {
						catalogId: utils.getURLParam(currentURL, 'catalogId'),
						storeId: utils.getURLParam(currentURL, 'storeId'),
						langId: utils.getURLParam(currentURL, 'langId'),
						searchTerm: utils.getURLParam(currentURL, 'searchTerm')
					};

					// Reset all filters and update products preserving core URL params
					history.replaceState(state, null, utils.setMultipleURLParams(state, false));
				} else {
					history.replaceState(null, null, utils.removeHash());
				}

				if(plpFiltersAndSortBtnEnabled) {
					if($('.filter-search-btn-js').hasClass('filters-expanded')) {
						$('.filter-search-btn-js').trigger('click');
					}
				}

				$.pubsub('publishSync', 'vfdp.wcs.product_list.RESET_FILTERS_CLICKED');

				var $defaultSort = $('.product-list-sort-by-default-option');
				if (plpResetSortOnClearAllFilters && $defaultSort.length > 0) {
					$('#sort-by').val($defaultSort.attr('value'));
				}
		});

		// Handle click and change events for product listing page
		$('#master-container').on({
			click: function (event,fetchPriceRangeFilter) {
				if (($("#facetPrice").val() !== "" && $("#priceFacetsliderEnabled").val()) && (typeof fetchPriceRangeFilter == 'undefined' || fetchPriceRangeFilter != 'true')) {
					return
				}
			    var $this = $(event.target),
					state,
					facetValue,
                    searchTerm,
					$productSearch = $('.ajax-product-search-js'),
					$label = $this.is('label') ? $this : $this.parents('label'),
					$closestDataFacetElement = $this.closest('[data-facet-value]'),
					$closestDataFilterOption = $this.closest('[data-filter-option]'),
					$facetValueElement = $closestDataFilterOption.length > 0 ? $closestDataFilterOption : $closestDataFacetElement;

					if ($facetValueElement.is(':button') &&
							($facetValueElement.hasClass('out-of-stock') ||
							$facetValueElement.hasClass('disabled') ||
							$facetValueElement.is('[disabled]'))
						) {
							return;
						}
			    // Labels bound to an input element fires the click event twice.
				// The filter event listener is attached to the #master-container element, a super-broad selector.
				// This is because a PLP can have filters on the top, right below the breadcrumbs.
                // For this reason the selector can't be made more specific and the event bubbling can't be prevented generally since
				// it could break the logic of other elements on the page that are not filters but still have click events attached.
                if ($label.length > 0 && $facetValueElement.length > 0 && !$this.is('input')) {
                    if(EVENT_DEBUG) console.log('MASTER CLUSTER FUBAR CLICK EVENT 1');

                    event.preventDefault();
                    event.stopPropagation();
                    var $checkBox = $facetValueElement.find("input[type='checkbox']");
                    $checkBox.trigger('click');
                    return false;
                }

				reloadFilters = false;
                // On devices when a filter is applied there is a manual click trigger on .filter-search-btn-js in order to close the
				// mobile filters overlay. This trigger causes the issue that the price filter is erased from the facetList after its applied
				// because we enter in here and call removePriceFacet()
                if ($("#facetPrice").val() !== "" &&
                    $("#priceFacetsliderEnabled").val() === 'true' &&
                    !$(event.target).hasClass('filter-search-btn-js')) {

                	if(EVENT_DEBUG) console.log('MASTER CLUSTER FUBAR CLICK EVENT 2');

                    facetValue = $("#facetPrice").val();
                    removePriceFacet(facetValue, facetList);
                    if (isEASearchTemplate && !isSimpleFacetEnabled) {
                        removePriceSliderFacetFromCatPath();
                    }
                } else {
                	if(EVENT_DEBUG) console.log('MASTER CLUSTER FUBAR CLICK EVENT 3');

                    facetValue = $this.data('facetValue') || $closestDataFacetElement.data('facetValue');
                }

				if (facetValue && $('body').hasClass('search') && isEASearchTemplate ){
					if(EVENT_DEBUG) console.log('MASTER CLUSTER FUBAR CLICK EVENT 4');

					facetValue = encodeURIComponent(facetValue);
				}

				var URL = $productSearch.data('value');

					if (plpMobileFiltersMultiSelectEnabled && $facetValueElement.length > 0) {
						if ($this.hasClass('facet-value')) {
							$this.children('.plp-checkbox').toggleClass('checked');
						} else if ($this.parent('.facet-value').length) {
							$this.parent('.facet-value').children('.plp-checkbox').toggleClass('checked');
						} else {
							$this.toggleClass('selected');
						}
						if ($this.hasClass('not-reset-filters') || $this.parent('.not-reset-filters').length) {
							reloadFilters = true;
						}
					}

				var requestAction = null;
				// toggle "open/close filters" button in mobile mode
				// has been moved up because  branch 'else if ($this.closest('.swatch-js')){' is blocking this event
				if ($this.hasClass ('filter-search-btn-js')){
					if(EVENT_DEBUG) console.log('MASTER CLUSTER FUBAR CLICK EVENT 5');

					$this.toggleClass('filters-expanded');
					$('.filters-section-js').toggleClass('is-visible');
					setFilterActionButtons();
				}
				else if ($this.hasClass ('apply-filter-js') || $this.hasClass('reset-filter-js')) {
					if(EVENT_DEBUG) console.log('MASTER CLUSTER FUBAR CLICK EVENT 6');
					if(plpMobileFiltersMultiSelectEnabled) {
						filterProducts(0);
					}

					$('.filter-search-btn-js').trigger('click');
				}
				else if ($this.hasClass('filter-actions-js')){
					if(EVENT_DEBUG) console.log('MASTER CLUSTER FUBAR CLICK EVENT 7');
					if (!$this.hasClass('show-less')){
						$this.addClass('show-less');
					} else {
						$this.removeClass('show-less');
					}
					productView.toggleFacets($this.parent());
				}
				else if ($this.attr ('data-action') === "show-more-swatches"){
					if(EVENT_DEBUG) console.log('MASTER CLUSTER FUBAR CLICK EVENT 8');

					//If PRODUCT_LIST.SWATCH_CLICK_REDIRECT_PDP_ENABLED set to true then redirect to PDP if clicked on more swatches(+N) button
					if(WCS_CONFIG.get("grid::redirectToPDPOnSwatchClickEnabled")){
						window.location.href = $($this.parents('.color-swatches-js').find('.swatch-js')[0]).data('productUrl');
					}else{
						productView.toggleMoreSwatches ($this.parents('.color-swatches-js'));
					}
				}
				else if ($this.closest('.swatch-js').length > 0){
					if(EVENT_DEBUG) console.log('MASTER CLUSTER FUBAR CLICK EVENT 9');

					//If PRODUCT_LIST.SWATCH_CLICK_REDIRECT_PDP_ENABLED set to true then redirect to PDP if clicked on any swatches

					if ( $this.closest('.swatch-js').data('hasPromo') === true ){
						$this.closest('.product-block-js').find('.espot-container').removeClass('hide');
					} else {
						$this.closest('.product-block-js').find('.espot-container').addClass('hide');
					}

					if(WCS_CONFIG.get("grid::redirectToPDPOnSwatchClickEnabled")){
						window.location.href = $($this).data('productUrl');
					}else{
						$.pubsub('publish', 'PLP.IMAGE_EVENT', event);
					}
				}
				else if ($this.hasClass('quickshop-js')){
					if(EVENT_DEBUG) console.log('MASTER CLUSTER FUBAR CLICK EVENT 10');

					productView.updateVariationId($this);
				}
				else if (($this.data('event') === 'click' && $this.data('action') === 'sort') || ($this.closest('.sort-by-option-js').data('event') === 'click' && $this.closest('.sort-by-option-js').data('action') === 'sort')) {
					if(EVENT_DEBUG) console.log('MASTER CLUSTER FUBAR CLICK EVENT 11');

					sortByOnClick($this);
				}
				else if ((facetValue || $this.hasClass('view-all-js')) && (!leftNavFilterDesktopWithMobileModal || (leftNavFilterDesktopWithMobileModal && (!($this.hasClass('disabled') || $this.parent().hasClass('disabled')) || $this.hasClass('checked'))))) {
					if(EVENT_DEBUG) console.log('MASTER CLUSTER FUBAR CLICK EVENT 12');

					var toggleFilter = true;

					lockLazyLoadAjax = false;
					if ($this.hasClass('facet-color') && leftNavFilterDesktopWithMobileModal) {
						var rgbBackground = $this.css("background-color");
						var hexColor = getHexColorFromRGB(rgbBackground);
						if (hexColor.includes('#')) {
							var betterColor = utils.compareContrast(hexColor, lightCheckMarkColor, darkCheckMarkColor);
							if (betterColor === darkCheckMarkColor) {
								$this.addClass('inverse-selection-check-color');
							}
						}
					}
					if (!$this.hasClass('view-all-js')){
						//HANDLES CLICK OF FACET CHECKBOX AND LABEL
						if(EVENT_DEBUG) console.log('MASTER CLUSTER FUBAR CLICK SUB EVENT 12a');
						if(enablePerformanceMarks) {
							facetClickDetected = true;
							performance.mark("facetClick");
						}

						facetList = updateFacetList (facetValue, facetList, event);
					}

					if ($('body').hasClass('search') && isEASearchTemplate && !isSimpleFacetEnabled) {
						if(EVENT_DEBUG) console.log('MASTER CLUSTER FUBAR CLICK SUB EVENT 12b');
						var path = $productSearch.data('catPath'),
							isCategory = $this.hasClass ('ea-category-js') || $closestDataFacetElement.hasClass('ea-category-js'),
                            currentURL = window.location.href;

						searchTerm  = utils.getURLParam(currentURL, 'searchTerm');
						requestAction = isCategory ? 'CA_CategoryExpand' : 'CA_AttributeSelected';

						if (eaMultiSelectFacetEnabled) {
							if(EVENT_DEBUG) console.log('MASTER CLUSTER FUBAR CLICK SUB EVENT 12c');
							requestAction = 'CA_BreadcrumbSelect';
							path = facetValue;
						}
						else if ($this.hasClass('remove-facet-js') || $closestDataFacetElement.hasClass('remove-facet-js')) {
							if(EVENT_DEBUG) console.log('MASTER CLUSTER FUBAR CLICK SUB EVENT 12d');
							requestAction = 'CA_BreadcrumbClick';
						}

						var facetValues = [];
                        facetValues.push(facetValue);
                        state = {facet : facetValues, catPath: path, requestData: requestAction, beginIndex : 0};

                        if (searchTerm) {
                        	if(EVENT_DEBUG) console.log('MASTER CLUSTER FUBAR CLICK SUB EVENT 12e');
                            state.searchTerm  = searchTerm;
                            state.catalogId = utils.getURLParam(currentURL, 'catalogId');
							state.storeId = utils.getURLParam(currentURL, 'storeId');
							state.langId = utils.getURLParam(currentURL, 'langId');
						}

                        var updatedUrl = utils.setMultipleURLParams(state, true);
                        history.replaceState(state, null, utils.setMultipleURLParamsFromHash(updatedUrl));
					}
					else {
						if ($('.apply-filter-js').length > 0 && $('.reset-filter-js').length > 0) {
							if(EVENT_DEBUG) console.log('MASTER CLUSTER FUBAR CLICK SUB EVENT 12f');
							toggleFilter = false;
                            doFetchProducts = true;
						} else if (facetList.length === 0) {
							//UNCHECKING FILTERS
							if(EVENT_DEBUG) console.log('MASTER CLUSTER FUBAR CLICK SUB EVENT 12g');
							if(enablePerformanceMarks) {
								facetClickDetected = false;
								performance.mark("facetRemoved");
							}

                            doFetchProducts = true;
						}

						if (facetList.length > 1) {
							facetList = utils.sortFacetParam(facetList);
						}

                        state = {facet : facetList, beginIndex : 0};
						toggleApplyBtnText(facetList);
                        history.replaceState(state, null, utils.setMultipleURLParams(state, true));
					}

					if (endlessScrollCookieExists) {
						if(EVENT_DEBUG) console.log('MASTER CLUSTER FUBAR CLICK SUB EVENT 12h');
						context.removeCookie(endlessScrollCookieName);
						endlessScrollCookieExists = false;
					}
					if (toggleFilter && screenSize.size() === 'small'){
						if(EVENT_DEBUG) console.log('MASTER CLUSTER FUBAR CLICK SUB EVENT 12i');
						if (!plpMobileFiltersMultiSelectEnabled && $('.filter-search-btn-js').hasClass('filters-expanded')) {
							$('.filter-search-btn-js').trigger('click');
						}
					}
				}
				else if ($this.data('action') === "start-lazy-loading"){
					if(EVENT_DEBUG) console.log('MASTER CLUSTER FUBAR CLICK EVENT 13');

					loadMoreProducts(URL, 0, false);
					enableLazyLoad = true;
					initSubscriptionToScroll();
				} else if($this.hasClass('load-more-btn-js')) {
					if(EVENT_DEBUG) console.log('MASTER CLUSTER FUBAR CLICK EVENT 14');

					loadMoreProducts(URL, 0, true);
					$.pubsub('publish', 'vfdp.wcs.product_list.LOAD-MORE-RESULTS');
				}
				else if ( ($this.hasClass('clear-all-filters-js') || $this.parent().hasClass('clear-all-filters-js')) || (leftNavFilterDesktopWithMobileModal && $this.hasClass('icon-redo') && $this.parent().hasClass('active-filters-meta') ) ){
                    if(EVENT_DEBUG) console.log('MASTER CLUSTER FUBAR CLICK EVENT 15');

                    event.preventDefault();
                    doFetchProducts = true;
                    doResetFilters = true;
					
                    // Reset all filters and update products
					if (filterProductLoad || (history.state !== null && history.state.facet !== null && history.state.facet.length > 0)) {
                    	history.replaceState(null, null, utils.getBaseUrl());
					}
					if(isEASearchTemplate) {
						requestAction = "CA_BreadcrumbClick";
						if(originalRequestAction === ""){
							originalRequestAction = $productSearch.data('catPath');
						}
						$productSearch.data({
							'catPath': originalRequestAction,
							'requestAction': requestAction
						});
					} else {
						var orderBy = history.state ? history.state.orderBy : utils.getParamFromHash('orderBy');
						sortByOnClick(null, orderBy);
					}
				}
				else if ($this.hasClass('filter-title-js')) {
					if(EVENT_DEBUG) console.log('MASTER CLUSTER FUBAR CLICK EVENT 16');

					$this.parent().toggleClass('collapsed');
				}

				if ($this.hasClass('sort-by-btn-js') || $this.parents('.sort-by-btn-js').length > 0){
					if(EVENT_DEBUG) console.log('MASTER CLUSTER FUBAR CLICK EVENT 17');

					var $facetsBtn = $('.facets-btn-js');
					if (!$facetsBtn.parent().hasClass('collapsed')){
						$facetsBtn.trigger('click');
					}
				}

				// only if going to PDP
				if ($this.hasClass('product-block-js') || $this.hasClass('main-view-js') || $this.closest('.view-js').length > 0) {
                    if(EVENT_DEBUG) console.log('MASTER CLUSTER FUBAR CLICK EVENT 18');

                    //set a cookie to remember where the user left off in any case
                    var productURL = $productSearch.data('value');
                    var clickedProductPartNumber = $this.closest('.product-block-js').data('partNumber');
                    var endlessScrollCookieValue = utils.setURLParam("", 'categoryId', utils.getURLParam(productURL, 'categoryId'));

                    context.setCookie(clickedProductCookieName, JSON.stringify({ 'partNumber': clickedProductPartNumber, 'scrollPosition': currentScrollPosition }));

                    searchTerm = utils.getURLParam(productURL, 'searchTerm');
                    endlessScrollCookieValue = utils.setURLParam(endlessScrollCookieValue, 'pages', pagesLoaded);
                    endlessScrollCookieValue = utils.setURLParam(endlessScrollCookieValue, 'scrollPosition', currentScrollPosition);
                    if (searchTerm) {
                        endlessScrollCookieValue = utils.setURLParam(endlessScrollCookieValue, 'searchTerm', searchTerm);
                    }
                    context.setCookie(endlessScrollCookieName, endlessScrollCookieValue);
                }
			},

			mouseover: function(event) {
				if(WCS_CONFIG.get("grid::isProductImageOfColorOnHoverEnabled"))
				{
					$.pubsub('publish', 'PLP.IMAGE_EVENT', event);
				}
			},

			change: function (event){
				var $this = $(event.target),
					value = $this.find(':selected').val();
				if ($this.data('action') === "sort") {
                    doFetchProducts = true;

					if ($this.data('ignoreChangeEvent') === undefined){
						var category = utils.getURLParam ( $('.ajax-product-search-js').data('value'), 'categoryId'),
							state = { orderBy : value, beginIndex : 0, categoryId : category};

						history.replaceState(state, null, utils.setMultipleURLParams(state, true));
					}
					else if ($('body').hasClass('ea-js') && $this.data('ignoreChangeEvent') !== undefined){
						sortByOnClick($this.find(':selected'));
					}
				}
			}
		});

		var $container = $('body');

		initSetupFacetUrlSearch();
		_toggleLazyLoading();

        initProductList($container);

		if (WCS_CONFIG.get('grid::isBloomReachCatEnabled') && WCS_CONFIG.get('global::isBloomReachMoreLinkEnabled')) {
			utils.showSearchWidgetMoreLink();
		}


		if(typeof sortByDropdownCategoryValue !== 'undefined' && sortByDropdownCategoryValue !== null && sortByDropdownCategoryValue !== '')
		{
			$('.sort-by-js option[value=' + sortByDropdownCategoryValue +']').prop('selected', 'selected').trigger('updateSkin');
		}
		//Set the load more button flag and hide button, if not enough data to show button
		if( $('.load-more-btn-js').length > 0) {
			displayLoadMoreButton = true;
			toggleLoadMoreButtonDisplay();
		}

		$('.facets-bar-js, .nav-sub-category-js').on('tap, click', function(e){
			var $this = $(e.target);
			if($this.hasClass('dd-select-btn-js')|| $this.parent().hasClass('dd-select-btn-js')){
				productView.toggleCustomDropDown ($($this.parents('.dd-select-js').eq(0)));
			}
		});

        _addFilterCloseButtonEventHandler();

		//Handle global scrolling and hashchange events
		$(window).on({
			replacestate: function(event) {
				if (!plpMobileFiltersMultiSelectEnabled || reloadFilters) {
						filterProducts(0);
					}
			},
			popstate : function() {
				filterProducts(0);
			}
		});

		function initSubscriptionToScroll(){
			if(DEBUG) console.log('initSubscriptionToScroll()');

			// Make sure the element is in the page
			var filtersBar = $('.product-list-refine-search-container');

			if (filtersBar.length !== 0) {
				var filtersBarHeight = filtersBar.height() || 0,
						filterBarOffset = filtersBar.offset(),
						filtersBarPosition = filterBarOffset.top + filtersBarHeight;
			}

			$.pubsub('subscribe', 'window.scroll', function (event, data) {
				// Cache current scroll position
				currentScrollPosition = data.now;

				if (screenSize.size() <= "small" && WCS_CONFIG.get("grid::plpStickyFiltersEnabled")) {
					stickFilterBarToHeader(currentScrollPosition, filtersBarPosition);
				}
				if (enableLazyLoad) {
					var shouldLoad = (
						!disallowScroll &&
						enableLazyLoad === true &&
						displayLoadMoreButton === false &&
						lockLazyLoadAjax === false
					);

					// Don't waste time calculating scroll requirements if the feature is disabled
					if(!shouldLoad) {
						return;
					} else {
						// Reset for the next set of detection rules
						shouldLoad = false;
					}

					var showSpinner = false,
						$productBlocks = $('.catalog-results-js .product-block'),
						$productList = $('.product-list-js'),
						productBlockOffset = $productBlocks.eq(0).height(),
						productListHeight = $productList.outerHeight(true),
						productListOffset = $productList.offset().top,
						URL = $('.ajax-product-search-js').data('value'),
						windowHeight = $(window).height();

					var secondToLastRow = productListOffset + productListHeight - productBlockOffset;

					// When scroll position is past the 2nd to last row, don't show a spinner
					if(currentScrollPosition + windowHeight >= secondToLastRow) {
						shouldLoad = true;
					}

					// When scroll position is past the list entirely, use a spinner
					if(currentScrollPosition + windowHeight >= productListOffset + productListHeight) {
						showSpinner = true;
						shouldLoad = true;
					}

					// Trigger the product load
					if(shouldLoad) {
						loadMoreProducts(URL, 0, showSpinner);
					}
				}
			});
		}

		function stickFilterBarToHeader (scrollPos, filtersBarPosition) {
			var headerHeight = $(".topnav-header").height();
			var smallHeaderHeight = $('.topnav-smallheader-container').height() || 0;
			var searchBar = $(".topnav-search-container");
			var promoBar = $(".topnav-promobar-container");
			var promoBarHeight = promoBar.height() || 0;
			var searchBarHeight = searchBar.height() || 0;
			var filtersBar = $(".product-list-refine-search-container");
			var scrolledStyles = {
				"top": smallHeaderHeight,
			};
			if ((scrollPos + promoBarHeight + searchBarHeight + headerHeight) >= filtersBarPosition) {
				searchBar.hide();
				promoBar.hide();
				filtersBar.addClass("sticky-search-container");
				filtersBar.css(scrolledStyles);
			} else {
				searchBar.show();
				promoBar.show();
				filtersBar.removeClass("sticky-search-container");
			}
		};
		initSubscriptionToScroll();

        $.pubsub('subscribe', 'window.resize.breakpoint', function(msg, data) {
            if(DEBUG) console.log('window.resize.breakpoint');
            if (screenSize.size() !== 'small') {
                var $filterButton = $('.filter-search-btn-js');

                if ($filterButton.hasClass('filters-expanded')) {
                    var altText = $filterButton.data('altText');
                    $filterButton.data('altText', $filterButton.text()).text(altText);
                }

                $filterButton.removeClass('filters-expanded');
                $('.filters-section-js').removeClass('is-visible');
            }

            productGrid.initializeSetHeight();
        });

		var endlessScrollCookie = context.getCookie(endlessScrollCookieName);

		//Check for the endless scroll cookie
		if (endlessScrollCookie) {
			var currentURL = $('.ajax-product-search-js').data('value');
            triggerScroll = true;

			//Check if the cookie applies to the current category
			if (utils.getURLParam(currentURL, 'categoryId').toString() === utils.getURLParam(endlessScrollCookie, 'categoryId') && utils.getURLParam(currentURL, 'searchTerm').toString() === decodeURIComponent(utils.getURLParam(endlessScrollCookie, 'searchTerm'))) {
                endlessScrollCookieExists = true;
                //Reset the cookie when landing on a new category
            } else {
                context.removeCookie(endlessScrollCookieName);
            }
		}

		var initialPageSize;
		var pageSizeForDevice;
		var partialPagesToLoad = 0;
		var fullPagesToLoad = 0;
		var filterProductLoad = false;
		var totalProductsCount;

		if(pageSizeByDeviceEnabled){
			initialPageSize = parseInt($('.products-per-page-js').val(), 10);
			totalProductsCount = parseInt($('.total-count-js').val(), 10);
			pageSizeForDevice = getPageSizeForDevice();

			if(initialPageSize < pageSizeForDevice && initialPageSize < totalProductsCount) {
				if (totalProductsCount - initialPageSize > initialPageSize) {
					partialPagesToLoad = (pageSizeForDevice - initialPageSize)/initialPageSize;
				} else {
					partialPagesToLoad = 1;
				}
			}
		}

		//Check if it has hash or the endless scroll cookie was set and refresh the page accordingly
		var scrollPosition = -1;

		if (window.location.hash.length > 0 || (endlessScrollCookieExists && $('.view-all-js').length === 0 && $('.search-group-js').length === 0)) {
			if (endlessScrollCookieExists) {
				scrollPosition = utils.getURLParam(endlessScrollCookie, 'scrollPosition');
				fullPagesToLoad = parseInt(utils.getURLParam(endlessScrollCookie, 'pages'));
			}

            if (window.location.hash.length > 0 && filterProductsOnPageLoad) {
                if(partialPagesToLoad > 0){
					filterProducts(partialPagesToLoad, true);
				}
				else {
					filterProducts(fullPagesToLoad); // ajax call made on page load to filter
				}

				filterProductLoad = true;
			}
		} else {
            context.removeCookie(endlessScrollCookieName);
			disallowScroll = false;
		}

		//Due to potential for only part of first page being fully loaded need to wait until entire first page is loaded before moving on...
		$.pubsub('subscribe', 'vfdp.wcs.product_list.ajax_partial_product_load_complete', function() {
			if(DEBUG) console.log('subscribe vfdp.wcs.product_list.ajax_partial_product_load_complete');

			if(fullPagesToLoad > 0)
                if (optimizeRequestsEnabled) {
                    loadMoreProducts($('.ajax-product-search-js').data('value'), fullPagesToLoad, false);
                } else {
                    loadMoreProducts($('.ajax-product-search-js').data('value'), fullPagesToLoad - 1, false);
                }
			else if( !$('body.search').length && !WCS_CONFIG.get("grid::unfilteredSearchInventorySensitive") && !WCS_CONFIG.get('HandleBarsModules::TopBarFacets')){
				var URL = $('.ajax-product-search-js').data('value');

				if(utils.getURLParam(URL, 'facet') === 0){
					URL = utils.setURLParam(URL, 'facet', "");	//pass facet to exclude OOS
					fetchProducts(URL, "REFRESH-FILTERS", 0, false, false);
				}
			}

			if (endlessScrollCookieExists) {
				context.removeCookie(endlessScrollCookieName);
				endlessScrollCookieExists = false;
				disallowScroll = false;
			} else if (window.performance && performance.navigation.type === 1) {
				$(window).scrollTop(0);
			}

			if(enablePerformanceMarks && filteringFacetsOnPageLoadDetected && BOOMRavailable) {
				filteringFacetsOnPageLoadDetected = false;
				performance.mark("filterProductsFromDeepLinkStop");
				var filterProductsFromDeepLinkStopMark = performance.getEntriesByName("filterProductsFromDeepLinkStop")[0];
				performance.measure("filterProductsFromDeepLinkTime", "filterProductsFromDeepLinkStart", "filterProductsFromDeepLinkStop");
				var filterProductsFromDeepLinkTimeMeasure = performance.getEntriesByName("filterProductsFromDeepLinkTime")[0];
				BOOMR.sendTimers({
      	  "filterProductsFromDeepLinkStop": filterProductsFromDeepLinkStopMark.startTime,
      	  "filterProductsFromDeepLinkTime": filterProductsFromDeepLinkTimeMeasure.duration
      	});
            }
		});

		if(!filterProductLoad){
			if(partialPagesToLoad > 0){	//Is a partial page load required for user to start with desired # of products?
                if (optimizeRequestsEnabled) {
                	loadMoreProducts($('.ajax-product-search-js').data('value'), partialPagesToLoad, false, true);
                } else {
                    loadMoreProducts($('.ajax-product-search-js').data('value'), partialPagesToLoad - 1, false, true);
				}
			}
			else {
				$.pubsub('publish', 'vfdp.wcs.product_list.ajax_partial_product_load_complete');
			}
		}

		//setup height for each product block after all images are loaded
		productGrid.initializeSetHeight();

		$(window).on('scroll', function() {
			if(DEBUG) console.log('scroll');
			setFilterActionButtons();
		});

		// Unused filters start in collapsed state when no filters have selection
		_collapseUnusedFilters();

		if (WCS_CONFIG.grid.productGridEnablePerformanceMarks) {
			performance.mark("Product Grid Init ready");
		}

		// add custom dropdown
		if(plpCustomSortByOptions) {
			customSortDropdown();
		}

		showHideFactesInitialize();
	});

	// load additional plugins
	pluginLoader.loadPlugins([
		{
			// Bloomreach Product Compare
			name: 'bloomreach-product-compare',
			selector: '.br_search_widget',
			initFunction: 'bloomreachProductCompare'
		}
	]);

	// load a price range slider in PLP, Search Page
	function initPriceRangeSlider() {
		var rangeSlider = $('#facet-price-range-slider');
		if(rangeSlider.length > 0) {
			require(['shared.range-slider'],function() {
				rangeSlider.RangeSlider({
					output: {
						format: function(output){
							return output.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
						},
						suffix: function(input){
							if (plpPriceRangeEnableEditableInputs) {
								return '';
							}
							return parseInt($(input).val()) == parseInt($(input).attr('max')) ? this.config.maxSymbol : '';
						}
					},
					enableEditableInputs: plpPriceRangeEnableEditableInputs,
					change: function(event, values){
						var min = values[0].value,
							calculateMaxValue = function () {
								if(values[1].value == values[1].max) {
									if(WCS_CONFIG.get('global::attraqtAPIEnabled') || plpPriceRangeEnableEditableInputs) {
										return values[1].max;
									} else {
										return '*';
									}
								} else {
									return values[1].value;
								}
							},
							max = calculateMaxValue(),
							isEASearchTemplate = $('.ea-js').length > 0 ? true : false,
							facetPrice;

						var isSimpleFacetEnabled = WCS_CONFIG.get('grid::facetEngine') === 'simpleFacets' ? true : false;

						if(isEASearchTemplate && !isSimpleFacetEnabled) {
							var pricePattern = "priceLabel='minValue@maxValue@minRangeValue@maxRangeValue'";
							pricePattern = pricePattern.replace(/priceLabel/gi, $(this.element).data('facet-label'));
							pricePattern = pricePattern.replace(/minRangeValue/gi, values[0].min);
							pricePattern = pricePattern.replace(/maxRangeValue/gi, values[1].max);
							pricePattern = pricePattern.replace(/minValue/gi, values[0].value);
							pricePattern = pricePattern.replace(/maxValue/gi, values[1].value);
							facetPrice = pricePattern;
						} else {
							var dataOptions = $(this.element).data('options');
							var facetLabel = dataOptions.pricePattern.label;
							var operand =  dataOptions.pricePattern.operand;
							var begin = dataOptions.pricePattern.begin;
							var middle = dataOptions.pricePattern.middle;
							var end = dataOptions.pricePattern.end;
							facetPrice = facetLabel + operand + begin + min + middle + max + end;
							facetPrice=encodeURIComponent(facetPrice);
						}
						$("#facetPrice").val(facetPrice);
						// This is a horrible, horrible, horrible way to do this,
						// But that's how it's coded to trigger the filters to update :(
						// Please revome this in the future.
						$( "#master-container" ).trigger('click','true');
					}
				});
			});
		}
	}

	// Setup collapse/expand description text
	function truncateTextDescription() {
		var $productShortDescription = $('.product-block-short-description-js');
		if ($productShortDescription.length > 0) {
			var isSmall = screenSize.size() === 'small';
			var shortDescriptionTruncateLength = isSmall ? shortDescriptionTruncateLengthSmall : shortDescriptionTruncateLengthLarge;
			$productShortDescription.on('click', function(e) {
				 var fullText= $(this).attr('data-text');
				 if (fullText.length > shortDescriptionTruncateLength){
					 var expanded = $(this).hasClass('expand');
					 if (!expanded) {
					$(this).html(fullText);
					 } else {
						 truncateEndSpace($(this),shortDescriptionTruncateLength);
					 }
					$(e.currentTarget).toggleClass('expand');
				 }
			});

			// Loop through short description elements and expands the ones
			// with specific text length
			for (var i = 0; i < $productShortDescription.length; i++) {
				var $el = $($productShortDescription[i]);
				$el.attr('data-text',$el.html());
				if ($el.html().length < shortDescriptionTruncateLength) {
					$el.addClass('expanded');
				} else {
					truncateEndSpace($el, shortDescriptionTruncateLength);
				}
			}
		}
	}

	function truncateEndSpace($element,truncateLength) {
		try {
			var fullText = $element.attr('data-text');
			var worddBreak = fullText[truncateLength] !== ' ';
			if (worddBreak) {
				while (truncateLength) {
					if (fullText[truncateLength] == ' ') break;
					truncateLength = truncateLength - 1;
				}
			}
			var newText= fullText.substring(0,truncateLength) + '...';
			$element.html(newText);
		} catch(err) {
			console.log(err);
		  }
	}

	// Initialize on page load
	initPriceRangeSlider();

	if (shortDescriptionTruncate) {
		truncateTextDescription();
	}

	// Initialize on product list load.
	$.pubsub('subscribe', 'vfdp.wcs.product_list.ajax_product_loaded', function() {
		initPriceRangeSlider();

		if (shortDescriptionTruncate) {
			truncateTextDescription();
		}

	});
});
